
import { useEffect } from 'react';
import { useNavigate, useParams, Outlet, useLocation } from 'react-router-dom';
import { Language } from '@/types/translations';

// Detectar idioma del navegador
const detectBrowserLanguage = (): Language => {
  const browserLang = navigator.language.split('-')[0];
  return browserLang === 'es' ? 'es' : 'en';
};

const LanguageRouter = () => {
  const { '*': pathParam } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // Determinar idioma basado en la URL
  const isEnglishRoute = location.pathname.startsWith('/en');
  const currentLanguage: Language = isEnglishRoute ? 'en' : 'es';

  useEffect(() => {
    // Si estamos en la raíz "/" y el navegador prefiere inglés, redirigir a /en
    if (location.pathname === '/' && detectBrowserLanguage() === 'en') {
      const savedLang = localStorage.getItem('language') as Language;
      if (!savedLang || savedLang === 'en') {
        navigate('/en', { replace: true });
        return;
      }
    }

    // Guardar idioma actual en localStorage
    localStorage.setItem('language', currentLanguage);
  }, [location.pathname, navigate, currentLanguage]);

  return <Outlet />;
};

export default LanguageRouter;
